module.exports = __webpack_public_path__ + "assets/ubuntu.44fada65.svg";